import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  axiosNewMechInstance,
  setJWTAuthHeader,
  clearJWTAuthHeader,
} from '../../services/api.js';

//User login +
export const logIn = createAsyncThunk(
  'auth/login',
  async (userData, thunkAPI) => {
    try {
      const { username, password } = userData;

      const body = new URLSearchParams();
      body.append('username', username);
      body.append('password', password);

      const response = await axiosNewMechInstance.post(
        '/api/v1/auth/login',
        body,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );

      const { access_token, refresh_token } = response.data;

      localStorage.setItem('accessToken', access_token);
      localStorage.setItem('refreshToken', refresh_token);

      setJWTAuthHeader(access_token);

      console.log('logInResponseData', response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// User logout +
export const logOut = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
  try {
    const state = thunkAPI.getState();

    const refreshToken =
      state.auth.refreshToken || localStorage.getItem('refreshToken');

    if (!refreshToken) {
      clearJWTAuthHeader();
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      return;
    }

    const response = await axiosNewMechInstance.post(
      '/api/v1/auth/logout',
      { refresh_token: refreshToken } // ✅ правильний body
    );

    clearJWTAuthHeader();
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');

    return response.data;
  } catch (error) {
    // 🔐 навіть якщо бек впав — фронт логаутиться
    clearJWTAuthHeader();
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');

    return thunkAPI.rejectWithValue(error.response?.status || 'LOGOUT_ERROR');
  }
});

//Get user data +
export const getUserData = createAsyncThunk(
  'auth/getUserData',
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewMechInstance.get('/api/v1/users/me');
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

//Get mechanic balance data +
export const getMechanicBalance = createAsyncThunk(
  'auth/getMechanicBalance',
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewMechInstance.get(
        `/api/v1/auth/get_balance`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Refresh user (hydrate + refresh token if needed) +
export const refreshUser = createAsyncThunk(
  'auth/refresh',
  async (_, thunkAPI) => {
    try {
      const accessToken = localStorage.getItem('accessToken');
      const refreshToken = localStorage.getItem('refreshToken');

      if (!accessToken || !refreshToken) {
        return thunkAPI.rejectWithValue('NO_TOKENS');
      }

      setJWTAuthHeader(accessToken);

      const response = await axiosNewMechInstance.get('/api/v1/users/me');

      return {
        user: response.data,
        access_token: accessToken,
        refresh_token: refreshToken,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message:
          error.response?.data?.message ||
          error.response?.data?.detail ||
          error.message ||
          'Network error',
      });
    }
  }
);
